var inMemoryStorage = {}
export const StorageFactory = (getStorage = () => Storage) => {
  const isSupported = () => {
    try {
      const testKey = 'is_local_storage_allowed'
      getStorage().setItem(testKey, testKey)
      getStorage().removeItem(testKey)
      return true
    } catch (e) {
      return false
    }
  }

  const clear = () => {
    if (isSupported()) {
      getStorage().clear()
      inMemoryStorage = {}
    } else {
      inMemoryStorage = {}
    }
  }

  const getItem = (name) => {
    if (isSupported()) {
      return getStorage().getItem(name)
    }
    if (inMemoryStorage.hasOwnProperty(name)) {
      return inMemoryStorage[name]
    }
    return null
  }

  const key = (index) => {
    if (isSupported()) {
      return getStorage().key(index)
    } else {
      return Object.keys(inMemoryStorage)[index] || null
    }
  }

  const removeItem = (name) => {
    if (isSupported()) {
      getStorage().removeItem(name)
    } else {
      delete inMemoryStorage[name]
    }
  }

  const setItem = (name, value) => {
    if (isSupported()) {
      getStorage().setItem(name, value)
    } else {
      inMemoryStorage[name] = String(value)
    }
  }

  const length = () => {
    if (isSupported()) {
      return getStorage().length
    } else {
      return Object.keys(inMemoryStorage).length
    }
  }

  return {
    getItem,
    setItem,
    removeItem,
    clear,
    key,
    length
  }
}



// WEBPACK FOOTER //
// ./widgetSrc/storageFactory.js